import React from "react";
import { Image, Grid, List, Divider } from 'semantic-ui-react';
import defaultLogo from "../../../../images/logo/logo-128.png";
import organizationImage from "../../../../images/svg/noti-community.svg";
import playbookImage from "../../../../images/svg/noti-designer.svg";
import contentImage from "../../../../images/svg/noti-content.svg";
import teamImage from "../../../../images/svg/noti-community.svg";
import initiativeImage from "../../../../images/svg/noti-initiatives.svg";
import accountImage from "../../../../images/svg/noti-account.svg";
import workspaceImage from "../../../../images/svg/noti-workspace.svg"
import { dispatch } from '@rematch/core';
import noDataImage from "../../../../images/common/no_data_image.svg";

import momentDate from './../../../../helpers/momentDate';
import momentTime from "./../../../../helpers/momentTime";
import PlaceholderExampleHeaderImage from './../../../drive/PlaceHolder/PlaceHolderLoading'
import EllipsisTooltip from "../../../common/EllipsisTooltip";


class AccountNotification extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loadingData: true,
            loadingState: props.loadingNotifications,
            limit: 25,
        }
    }

    componentDidMount() {
        this.refs.iScroll.addEventListener("scroll", () => {
            if (this.refs.iScroll.scrollTop + this.refs.iScroll.clientHeight >= this.refs.iScroll.scrollHeight) {
                this.loadMoreItems();
            }
        });
    }

    loadMoreItems() {

        if (this.props.allNotification.total !== this.props.allNotification.data.length) {
            this.setState({ loadingState: true });
            setTimeout(async () => {
                let payload = {
                    name: this.props.filterQuery.name,
                    serviceName: this.props.filterQuery.serviceName,
                    sortingType: this.props.filterQuery.sortingType,
                    limit: this.state.limit + 10
                }
                await dispatch.notifications.setFilterQueryData(payload)
                dispatch.notifications.getNotifications({});
                this.setState({ limit: this.state.limit + 10, loadingState: false });
            }, 1000);
        }
    }

    render() {
        const { allNotification } = this.props

        let windowHeight = window.innerHeight;


        return (
            <div className="mar_10 " ref="iScroll" style={{ maxHeight: windowHeight - 150, overflow: "auto", display: "grid" }}>
                {allNotification && allNotification.data && allNotification.data.map((item, i) => {
                    let organization = item.organizationId && item.organizationId._id;
                    let account = item.accountId && item.accountId._id;

                    let imageIcon = item.category === "playbook" ? playbookImage :
                        item.category === "organization" ? organizationImage :
                            item.category === "content" ? contentImage :
                                item.category === "initiative" ? initiativeImage :
                                    item.category === "team" ? teamImage :
                                        item.category === "accounts" ? accountImage : 
                                        item.category === "Workspace" ? workspaceImage : null;

                    let subtype = item.subtype === "information" ? "information" :
                        item.subtype === "actionable" ? "actionable" : null;

                    return (
                        <List
                            style={{ margin: "0 0 10px 0" }}
                            className={`w_100 notificationBlock bg-white ${subtype}`}
                            key={i}
                        >
                            <List.Item className="w_100" style={{ padding: "5px 10px" }} key={1}>
                                <Image
                                    style={{ width: "24px", margin: "3px 0 0 0", objectFit: "cover" }}
                                    src={(item.accountId && item.accountId.logo) ? item.accountId.logo : defaultLogo}
                                />
                                <List.Content
                                    style={{ width: "calc(100% - 150px)" }}>
                                    <List.Header>
                                        <EllipsisTooltip
                                            name={account ? item.accountId.name : item.entityData  ? item.entityData.name : null}
                                            style={{ lineHeight: '18px' }}
                                        />
                                    </List.Header>
                                    <EllipsisTooltip
                                        name={organization ? item.organizationId.name : null}
                                        style={{ lineHeight: '16px' }}
                                    />
                                </List.Content>
                                <div className="float-right text-right f_11" >
                                    <div style={{ margin: "0 0 3px 0" }}>{momentDate(item.createdAt)}   </div>
                                    <div> {momentTime(item.createdAt)}</div>
                                </div>
                            </List.Item>
                            <Divider className="mar_0" />
                            <List.Item className="w_100" style={{ padding: "5px 10px" }} key={2}>
                                <Image
                                    style={{ width: "18px", margin: "0 3px 0" }}
                                    src={imageIcon}
                                />
                                <List.Content verticalAlign='top' style={{ width: "calc(100% - 24px)" }}>
                                    <EllipsisTooltip
                                        name={item.message}
                                        line={2}
                                        style={{ lineHeight: "16px" }}
                                    />
                                </List.Content>
                            </List.Item>
                        </List>
                    )
                })
                }

                {this.state.loadingState ? <PlaceholderExampleHeaderImage repeat={5} /> :
                    (allNotification && allNotification.data && allNotification.data.length === 0) ||
                        (allNotification && allNotification.data && allNotification.data.length === null) ?
                        <Grid className="notificationPane">
                            <Grid.Row columns={1} className="fixBlock" >
                                <div className="noUpdates">
                                    <Image src={noDataImage} />
                                    <h3>That's all. No more updates.</h3>
                                </div>
                            </Grid.Row>
                        </Grid> : null}
            </div>

        );
    }
}
export default AccountNotification;
